import * as React from "react";
import {Button} from "react-bootstrap";
import {defineMessages, InjectedIntlProps, injectIntl} from "react-intl";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {ConfirmationDialog} from "../common/ui/ConfirmationDialog";

interface DeleteCustomPropertyButtonProperties {
  onDelete: () => any;
  isConfirmDisabled?: boolean;
  bsSize?: string;
}

interface DeleteCustomPropertyButtonState {
  isDialogOpen: boolean;
}

const MESSAGES = defineMessages({
  confirmButtonText: {
    id: "studio.data.detail.customProperty-delete.confirm-button-text",
    defaultMessage: "Delete"
  },
  renderConfirmation: {
    id: "studio.data.detail.customProperty-delete.render-confirmation",
    defaultMessage: "Are you sure you want to delete this property?"
  },
  title: {
    id: "studio.data.detail.customProperty-delete.dialog-title",
    defaultMessage: "Delete Property"
  }
});

export class DeleteCustomPropertyButtonComponent extends React.Component<InjectedIntlProps & DeleteCustomPropertyButtonProperties, DeleteCustomPropertyButtonState> {

  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
    };
  }

  openDialog = () => {
    this.setState({isDialogOpen: true});
  }

  closeDialog = () => {
    this.setState({isDialogOpen: false});
  }

  renderButton() {
    return (
        <Button className="btn-icon"
                style={{backgroundColor: "transparent", float: "right", color: "currentColor"}}
                bsSize={this.props.bsSize as any || null}
                onClick={this.props.isConfirmDisabled ? this.props.onDelete : this.openDialog}>
          <LcdIcon icon="delete"/>
        </Button>
    );
  }

  render() {
    const {isDialogOpen} = this.state;
    const {intl, onDelete} = this.props;

    return (
        <div>
          {this.renderButton()}
          <ConfirmationDialog
              show={isDialogOpen}
              intl={intl}
              renderConfirmation={() => {
                return (
                    <div>
                      {intl.formatMessage(MESSAGES.renderConfirmation)}
                    </div>);
              }}
              confirmButtonIcon={"delete"}
              confirmButtonText={intl.formatMessage(MESSAGES.confirmButtonText)}
              onConfirm={onDelete}
              executing={null}
              executingMessage={null}
              error={null}
              warnings={null}
              success={null}
              successMessage={null}
              title={intl.formatMessage(MESSAGES.title)}
              onHide={this.closeDialog}
          />
        </div>
    );
  }
}

export const DeleteCustomPropertyButton = injectIntl(DeleteCustomPropertyButtonComponent);
